/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import Styles from './styles.module.sass'
import { FaCloudUploadAlt } from 'react-icons/fa'
import { SELECT_FILE_TO_UPLOAD, SUPPORTED_FILES_TO_UPLOAD } from '@/configs/strings/assets'
import { Flex, useBreakpointValue } from '@chakra-ui/react'
import { useResponsive } from '@/hooks/useResponsive'

const DropZone = () => {
  const { flexDirection, flexGap } = useResponsive()
  const textAlign = useBreakpointValue({
    base: 'text-center',
    md: ''
  })
  const gap = useBreakpointValue({
    base: flexGap,
    md: '30px'
  })
  return (
    <div className="dropzone-content">
      <Flex
        flexDirection={flexDirection}
        gap={gap}
        className={`file ${Styles.dragDropContainer} p-5`}
      >
        <Flex
          gap={flexGap}
          className="items-center"
        >
          <p className="has-text-weight-bold">+ Choose File</p>
          <FaCloudUploadAlt size="30"/>
        </Flex>
        <div className={textAlign}>
          <p className="has-text-weight-semibold">
            { SELECT_FILE_TO_UPLOAD }
          </p>
          <p className="is-size-7">
            { SUPPORTED_FILES_TO_UPLOAD }
          </p>
        </div>
      </Flex>
    </div>
  )
}

export default DropZone
